var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95508 6.50586H5.95508H21.9551",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9551 6.50586V20.5059C19.9551 21.0363 19.7444 21.545 19.3693 21.9201C18.9942 22.2951 18.4855 22.5059 17.9551 22.5059H7.95508C7.42465 22.5059 6.91594 22.2951 6.54086 21.9201C6.16579 21.545 5.95508 21.0363 5.95508 20.5059V6.50586M8.95508 6.50586V4.50586C8.95508 3.97543 9.16579 3.46672 9.54086 3.09165C9.91594 2.71657 10.4246 2.50586 10.9551 2.50586H14.9551C15.4855 2.50586 15.9942 2.71657 16.3693 3.09165C16.7444 3.46672 16.9551 3.97543 16.9551 4.50586V6.50586",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9551 11.5059V17.5059",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9551 11.5059V17.5059",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.526f3272462996b20757416298f38b83.svg";
export { ForwardRef as ReactComponent };